import useSessionStore from '@/stores/session';
import $api from '@/utils/api';
import $path from '@/utils/path';

export default {
  /**
   * Validates the currently stored session in the vuex store
   */
  async validateSession() {
    const SessionStore = useSessionStore();

    if (!SessionStore.token && !navigator.onLine) {
      return false;
    }

    try {
      const result = await $api.get('/sessions');
      return result.success;
    } catch (error) {
      return false;
    }
  },

  async login(email, password, backward) {
    const SessionStore = useSessionStore();

    const result = await $api.post('/sessions', { email, password });
    const { newToken } = result;

    if (!newToken) {
      throw new Error('Login info is incorrect.');
    }

    SessionStore.updateAuthToken({ newToken });
    window.location.replace($path.resolveApp() + (backward || ''));
  },

  logout() {
    const SessionStore = useSessionStore();
    SessionStore.clearSession();
    window.location.replace($path.resolveApp());
  },
};
